var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"dropdown-menu-item",class:{
    'dropdown-menu-item-disabled': _vm.disabled,
    'dropdown-menu-item-divided': _vm.divided,
  },style:(_vm.style),attrs:{"text":_vm.text},on:{"click":function($event){$event.stopPropagation();return _vm.handleClick.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }